import * as React from 'react';
import { CoreButtonNext as ButtonNext } from '../internal/WixUiCoreComponents/components/CoreButtonNext';
import { Text } from '../Text';
import { EVENT_DATA_KEYS } from './dataHooks';
import { st, classes } from './Event.st.css';
/** Event */
export class Event extends React.Component {
    constructor() {
        super(...arguments);
        this._getEventProps = (isContainer) => isContainer
            ? {
                'data-hook': this.props['data-hook'],
                ...this.getDataAttributes(),
                [EVENT_DATA_KEYS.ARIA_Has_Popup]: this.props['aria-has-popup'],
                [EVENT_DATA_KEYS.ARIA_Expanded]: this.props['aria-expanded'],
            }
            : null;
        this._getEvent = (isContainer, className, timeComponent, title) => (React.createElement("div", { ...this._getEventProps(isContainer), className: st(classes.root, { fullday: this.props.fullday, selected: this.props.selected }, className) },
            timeComponent,
            React.createElement(Text, { className: classes.title }, title),
            React.createElement("div", { className: classes.overlay })));
    }
    getDataAttributes() {
        const { fullday, selected, showTime } = this.props;
        return {
            [EVENT_DATA_KEYS.IsFullDay]: fullday,
            [EVENT_DATA_KEYS.IsSelected]: selected,
            [EVENT_DATA_KEYS.IsTimeShown]: showTime,
        };
    }
    render() {
        const { time, title, showTime, className, onClick, disabled } = this.props;
        const timeComponent = showTime && time ? React.createElement(Text, { className: classes.time }, time) : null;
        return onClick ? (React.createElement(ButtonNext, { disabled: disabled, onClick: () => !disabled && onClick(), className: st(classes.buttonContainer), ...this._getEventProps(true) }, this._getEvent(false, className, timeComponent, title))) : (this._getEvent(true, className, timeComponent, title));
    }
}
Event.displayName = 'Event';
Event.defaultProps = {
    showTime: true,
    fullday: false,
    selected: false,
    disabled: false,
    onClick: null,
    'aria-has-popup': false,
    'aria-expanded': false,
};
//# sourceMappingURL=Event.js.map